import angular from 'angular';
import ImageUploaderComponent from './image-uploader.ng1.component';
import Components from './components/components';

const ImageUploaderModule = angular
    .module('control-room.commons.content.components.image-uploader', [Components.name])
    .component('crImageUploader', ImageUploaderComponent);

export default ImageUploaderModule;
